import React from "react";
import { LineName } from "./LineName";
import { fmtQty } from "../utils/idGenerators";

/** Editable list of {internalCode, qty} lines. Items are chosen via the ItemPickerModal
 *  (the parent opens it through onAdd / onReplace); each line resolves its item via byCode.
 *  suggestions[i] (optional, inputs only): sibling-substitution candidates for a short line —
 *  [{code, stock}], sorted by stock descending; empty/absent → no hint, zero visual change.
 *  onSubstitute(i, code) (optional): swap line i to a suggested sibling. A line carrying
 *  `substituteFor` (set by onSubstitute) shows a "Substitusi untuk X" chip after its name. */
export default function LineEditor({ title, lines, byCode, onChange, onAdd, onReplace, max, maxHint, onCreateSet, onCreateItem, pendingCodes = new Set(), suggestions = [], onSubstitute }) {
  const setLine = (i, patch) => onChange(lines.map((l, idx) => (idx === i ? { ...l, ...patch } : l)));
  const removeLine = (i) => onChange(lines.filter((_, idx) => idx !== i));
  const atMax = typeof max === "number" && lines.length >= max;
  return (
    <div className="card">
      <div className="card__title">{title}</div>
      {lines.length === 0 && <div className="form-hint" style={{ marginBottom: "var(--gap-sm)" }}>Belum ada baris.</div>}
      {lines.map((l, i) => {
        const lineSuggestions = suggestions[i] || [];
        return (
          <React.Fragment key={i}>
            <div className="line-row">
              <button type="button" className="line-pick" onClick={() => onReplace(i)}>
                <span>
                  {l.internalCode
                    ? (<>
                        <span className="mono">{l.internalCode}</span> · <LineName line={l} byCode={byCode} />
                        {pendingCodes.has(l.internalCode) && <span className="chip chip--baru" style={{ marginLeft: "var(--gap-sm)" }}>baru</span>}
                        {l.substituteFor && <span className="chip chip--muted" style={{ marginLeft: "var(--gap-sm)" }}>Substitusi untuk {l.substituteFor}</span>}
                      </>)
                    : <span className="form-hint">— pilih barang —</span>}
                </span>
                <span className="line-pick__change">ganti</span>
              </button>
              <input className="form-input qty" type="number" min="1" value={l.qty}
                onChange={(e) => setLine(i, { qty: e.target.value })} />
              <button type="button" className="btn btn-ghost btn-sm" title="Hapus baris"
                onClick={() => removeLine(i)}>✕</button>
            </div>
            {lineSuggestions.length > 0 && (
              <div className="form-hint" style={{ marginTop: -4, marginBottom: "var(--gap-sm)", display: "flex", alignItems: "center", gap: "var(--gap-sm)", flexWrap: "wrap" }}>
                <span>⚠ Stok kurang — pakai saudara:</span>
                {lineSuggestions.map((s) => (
                  <button key={s.code} type="button" className="btn btn-sm btn-outline"
                    onClick={() => onSubstitute(i, s.code)}>
                    {s.code} ({fmtQty(s.stock)})
                  </button>
                ))}
              </div>
            )}
          </React.Fragment>
        );
      })}
      {atMax
        ? (maxHint ? <div className="form-hint">{maxHint}</div> : null)
        : (
          <div style={{ display: "flex", gap: "var(--gap-sm)", flexWrap: "wrap" }}>
            <button type="button" className="btn btn-sm" onClick={onAdd}>+ Pilih barang</button>
            {onCreateSet && (
              <button type="button" className="btn btn-sm btn-outline" onClick={onCreateSet}>+ Buat SET baru</button>
            )}
            {onCreateItem && (
              <button type="button" className="btn btn-sm btn-outline" onClick={onCreateItem}>+ Buat barang baru</button>
            )}
          </div>
        )}
    </div>
  );
}
